import Row from "../../../../components/Common/Row";
import Col from "../../../../components/Common/Col";
import { formatCurrency } from "../../../../utils/Format";
import { handlingCost, hfInformationCost, informationCost, totalCost } from "../../../../utils/Cost";
import { OrderCategory, TApiOrderDetails, TOrderCostV1 } from "../../../../api/endpoints/Order";
import React, { Fragment } from "react";

interface IProps {
  cost: TOrderCostV1;
  orderCategory: OrderCategory;
  annualTotalCostFootnoteRef?: string;
}

const OrderCostSummaryV1 = (props: IProps) => {
  const { orderCategory, cost, annualTotalCostFootnoteRef } = props;

  return (
    <Fragment>
      {
        orderCategory !== 'archive' &&
        <Row>
          <Col sm={12} md={10}>
            Annual Information Cost
          </Col>
          <Col sm={12} md={2}>
            {
              formatCurrency(informationCost(cost))
            }
          </Col>
        </Row>
      }

      {
        (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT) &&
        <Row>
          <Col sm={12} md={10}>
            Annual High Frequency Products Information Cost
          </Col>
          <Col sm={12} md={2}>
            {
              formatCurrency(hfInformationCost(cost))
            }
          </Col>
        </Row>
      }

      <Row>
        <Col sm={12} md={10}>
          Annual ECMWF handling charge
        </Col>
        <Col sm={12} md={2}>
          {
            formatCurrency(handlingCost(cost))
          }
        </Col>
      </Row>

      <Row>
        <Col sm={12} md={10}>
          <strong>Annual total cost</strong>
          {annualTotalCostFootnoteRef && <sup>{annualTotalCostFootnoteRef}</sup>}
        </Col>
        <Col sm={12} md={2}>
          <strong>
            {
              formatCurrency(totalCost(cost))
            }
          </strong>
        </Col>
      </Row>
    </Fragment>
  )
}

export default OrderCostSummaryV1;
